import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      {/* Special Offer Banner */}
      <div className="bg-[#d97706] text-white py-2 px-4 text-center text-base font-semibold">
        Call: (425) 890-2558
      </div>
      
      {/* Main Header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center space-x-2 lg:space-x-3 min-w-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_pro-trucker-learn/artifacts/g2xcv5lg_Diamond-Trucking-Logo.jpg" 
              alt="Diamond Trucking School" 
              className="h-10 w-10 lg:h-16 lg:w-16 object-contain flex-shrink-0"
            />
            <div className="min-w-0">
              <h1 className="text-base lg:text-2xl font-bold text-[#1e3a5f] truncate">Diamond Trucking School</h1>
              <p className="hidden sm:block text-sm lg:text-base italic font-bold text-gray-600 truncate">Your Path to Success</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-7">
            <button onClick={() => scrollToSection('home')} className="text-lg text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection('schedule')} className="text-lg text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Schedule
            </button>
            <button onClick={() => scrollToSection('programs')} className="text-lg text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Programs
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-lg text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              FAQ
            </button>
            <button onClick={() => window.location.href = '/fleet'} className="text-lg text-gray-700 hover:text-[#d97706] font-medium transition-colors" data-testid="nav-fleet-link">
              Fleet Training
            </button>
            <Button onClick={() => scrollToSection('contact')} variant="outline" className="border-[#d97706] text-[#d97706] hover:bg-[#d97706] hover:text-white text-base px-6 py-2.5">
              Contact Us
            </Button>
            <Button onClick={() => window.location.href = 'tel:4258902558'} className="bg-[#1e3a5f] hover:bg-[#152940] text-white text-lg font-bold px-6 py-2.5" data-testid="header-call-btn">
              <Phone className="w-5 h-5 mr-2" />
              425.890.2558
            </Button>
          </nav>

          {/* Mobile: phone + menu button */}
          <div className="flex items-center gap-3 lg:hidden flex-shrink-0">
            <a href="tel:4258902558" className="text-lg font-bold text-[#1e3a5f] whitespace-nowrap" data-testid="mobile-header-phone-link">
              425.890.2558
            </a>
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#d97706] transition-colors"
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4 space-y-2">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left py-2 text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection('schedule')} className="block w-full text-left py-2 text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Schedule
            </button>
            <button onClick={() => scrollToSection('programs')} className="block w-full text-left py-2 text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              Programs
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left py-2 text-gray-700 hover:text-[#d97706] font-medium transition-colors">
              FAQ
            </button>
            <button onClick={() => window.location.href = '/fleet'} className="block w-full text-left py-2 text-gray-700 hover:text-[#d97706] font-medium transition-colors" data-testid="mobile-nav-fleet-link">
              Fleet Training
            </button>
            <Button onClick={() => scrollToSection('contact')} variant="outline" className="w-full border-[#d97706] text-[#d97706] hover:bg-[#d97706] hover:text-white mt-2">
              Contact Us
            </Button>
            <Button onClick={() => window.location.href = 'tel:4258902558'} className="w-full bg-[#1e3a5f] hover:bg-[#152940] text-white mt-2" data-testid="mobile-call-btn">
              <Phone className="w-4 h-4 mr-2" />
              (425) 890-2558
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};